<div class="context-menu" [style]="{'top': y+'px', 'left': x+'px'}">
    <p><strong>Crear tarea:</strong></p>
    <ul *ngFor="let option of options">
      <li (click)="onOptionClick(option)"><i [ngClass]="option.icon"></i> {{option.label}}</li>
    </ul>
</div>